/**
 * Returns true if n is a number greater than 0.
 * @param n - number to test
 * @returns true if positive
 */
export function isPositive(n: number | undefined): boolean {
  return n !== undefined && n > 0;
}
